<section class="solutions">
    <div class="section-name">
        <h6>Use our solutions</h6>
        <div class="line"></div>
    </div>
    <div class="solutions-wrapper">
        <div class="solutions-text">
            <span class="d-flex justify-content-center m-auto"><b>Customers choose WorldERP® for maximized cost savings, capabilities, and growth</b></span>
            <p>
                Most current Enterprise Resource Planning (ERP) solutions are agile and secure however, only WorldERP®
                extends ERP to maximize productivity and a multi-jurisdictional footprint through our proprietary blend
                of hyperconvergence, hyperautomation, Artificial Intelligence (AI), intelligent workflows, strengthened
                compliance, and our simple to use interfaces that are wizard-driven to nearly eliminate training
                requirements and promote ease of use for superior user adoption. 
            </p>
        </div>
    </div>
    <div class="solutions-items">
        <div class="container">
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="ERP" class="info-title">ERP with Global Capability</h5>
                        <p class="info-text">
                            Our ERP allows you to connect entities, in the same country or in different countries, using dissimilar ERP,
                            Financial Accounting Systems, and localized compliance requirements into one backbone using our proprietary Colony™
                            technology to provide true Top-Down Command & Control exceeding the US Military’s JV2020 goals and objectives.
                        </p>
                        <div>
                            <a target="_blank" href="../../../assets/solutions/Datasheets/ERP_Datasheet_v1010.2.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/globalPresence.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/Bidding.png" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="ProRFx" class="info-title">ProRFx® (e-Sourcing/Bidding Solution)</h5>
                        <p class="info-text">
                            ProRFx® is the most advanced and easy to use bid management solution available to date. Using templates and our hyperconvergence,
                            hyperautomation, and AI technologies along with our simple wizard-driven processes, ProRFx® empowers the most novice user with
                            the ability to create robust solicitations, like Request for Proposals, in five minutes or less; and provides automated scoring
                            and tabulation for whole bid, by line item, and ordinal ranking!<br/><br/>
                            Best of all, ProRFx® helps maintain your organizations polices by automatically including forms, documents, and content that is
                            required for the type of solicitation being created!<br/><br/>
                            No more searching for the most up-to-date version of your organization’s Terms & Conditions or trying to determine if an 
                            Anti-Lobbying Agreement is needed, ProRFx® does it all for you to achieve significant process efficiencies and cost savings. <br/><br/>
                            Easily schedule and conduct in-person or virtual meetings, such a Pre-Bid meetings, and record within secure or publicly
                            accessible channels to take compliance to the next level. <br/><br/>
                            ProRFx® can dynamically interface with all of our other products and API enabled solutions providing unmatched for power and flexibly.
                        </p>
                        <div>
                            <a target="_blank" href="https://www.iconnectfx.com/view/bb2d3201-3a02-eb11-9977-00505682f257">VIDEO 1</a> | 
                            <a target="_blank" href="https://www.iconnectfx.com/view/d02d3201-3a02-eb11-9977-00505682f257">VIDEO 2</a> | 
                            <a target="_blank" href="https://www.prorfx.com/Help/Docs/ProRFx_Datasheet_v3.3_Full.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="ContractFX" class="info-title">ContractFX™ (Contract Lifecycle Management)</h5>
                        <p class="info-text">
                            With hyperconvergence, hyperautomation, and AI, ContractFX™ can manage all aspects of a contract from creation to milestone
                            performance and management to contract closeout. Manage labor, expenses, sourcing, purchasing, and even trouble ticketing
                            to not only gain valuable insight but control and management of everything associated with a contract from labor to material
                            to help ensure the contract is complete in time and on budget.<br /><br/> 
                            Our AI system will alert you real-time of potential budgetary concerns and delays years in advance. Easily conduct web conferences
                            with staff on-site or Live Stream, post video/photos online within secure or publicly accessible channels to take participation
                            to the next level.<br/><br/>  
                            ContractFX™ can dynamically interface with all of our other products and API enabled solutions providing unmatched for power and flexibly.
                        </p>
                        <div>
                            <a target="_blank" href="https://www.iconnectfx.com/view/bc2d3201-3a02-eb11-9977-00505682f257">VIDEO 1</a> | 
                            <a target="_blank" href="https://www.iconnectfx.com/view/ce2d3201-3a02-eb11-9977-00505682f257">VIDEO 2</a> | 
                            <a target="_blank" href="https://www.contractfx.com/Upload/WERP_ContractMgmt_Datasheet_v4.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/ContractManagement.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/SMP.png" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="SpendManagerPro" class="info-title">SpendManagerPro™  (Procurement-Through-To-Payment)</h5>
                        <p class="info-text">
                            Organizations see the importance of an existing (turnkey), internet-based, private marketplace that can be deployed and quickly
                            customized to meet their strategic procurement requirements and support a wide array of suppliers, contracts and commodities.<br/><br/>
                            The SpendManagerPro™ e-Procurement solution is fast and simple to set up and provides core functionality such as: supplier
                            interconnectivity, internal and external catalog management, requisition creation and management, security, administration,
                            intelligent workflows, reporting, and a variety of plug-in modules.  Additionally, SpendManagerPro™ can dynamically interface
                            with all of our other products providing unmatched for power and flexibly.<br/><br/>
                            If you come to work each day trying to figure out how you’re going to manage costs and risks, or your time is consumed juggling
                            processes on multiple systems, managing vendors, and wrangling with users who want to do things their own way, then it may be
                            time for you to seriously consider SpendManagerPro™.<br/><br/>
                            SpendManagerPro™ can replace, or integrate with your existing ERP/Financial Accounting system to turbocharge its efficiency by 
                            providing a user friendly, feature rich, front end and powerful modules that will unleash the true power of your existing system.<br/><br/>
                            Our solutions are designed to help overcome the challenges associated with too many directives, conflicting priorities, and not enough
                            capabilities to quickly manage tasks.<br/><br/>
                            With on-the-fly configuration and automated task management, SpendManagerPro™ can minimize both time
                            and resource requirements while helping ensure compliance.<br/><br/>
                            SpendManagerPro™ can dynamically interface with all of our other products and API enabled solutions
                            providing unmatched for power and flexibly.<br/><br/>
                            Now, just imagine what you could accomplish with procurement software solutions that deliver, all in one place…<br/><br/>
                        </p>
                            <u>OPTIONS</u>
                            <ul class="text-left">
                                <li>Grant Lifecycle Management</li>
                                <li>Asset Lifecycle Management</li>
                                <li>Product Lifecycle Management</li>
                                <li>Benchmarking</li>
                                <li>Support Services</li>
                            </ul>
                        <div>
                            <a target="_blank" href="https://www.iconnectfx.com/view/bd2d3201-3a02-eb11-9977-00505682f257">VIDEO </a> | 
                            <a target="_blank" href="https://www.spendmanagerpro.com/smp-welcome/HelpFiles/SMPro_General_Datasheet_v2013.2.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="iConnectFX" class="info-title">iConnectFX™<br/> (Event Management, Web-Conferencing, Distance Learning, and Video Sharing Platform)</h5>
                        <p class="info-text">
                            iConnectFX™ is the world’s first and only hyper-converged community engagement platform that combines the functionality of six(6)<br>
                            separate applications (listed below) into one seamless solution to maximize efficiencies, reduce support requirements, and increase automation & scalability all while cutting costs:
                        </p>
                        <ul class="text-left">
                            <li>Event Management (In-Person and Virtual)</li>
                            <li>Secure Webinar & Online Conferencing</li>
                            <li>Truly Interactive Distance Learning</li>
                            <li>Live Streaming with mobile capability</li>
                            <li>Video Sharing Platform</li>
                            <li>Multi-Language Translations</li>
                            <li>e-Commerce Shopping</li>
                        </ul>
                        <div>
                            <a target="_blank" href="https://www.iconnectfx.com/view/f52d3201-3a02-eb11-9977-00505682f257">VIDEO </a> |  
                            <a target="_blank" href="https://iconnectfx.com/Upload/iConnectFX_Datasheet.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/DistanceLearning.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/WorldCMMS.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="WorldCMMS" class="info-title">WorldCMMS™ <br/>(Computerized Maintenance Management System)</h5>
                        <p class="info-text">
                            WorldCMMS™ is a cost effective, enterprise solution for property and facility management; management of industrial plants,
                            buildings, equipment, vehicles, and all other assets as well as installations, and maintenance activities.<br/><br/>
                            WorldCMMS™ makes is simple to monitor the status of, and develop a documented maintenance (scheduled, meter-based and breakdown)
                            management process for, all your important assets in one place which are compliant with your business rules and best practices. <br/><br/>
                            WorldCMMS™ helps prioritize, organize and update all lifecycle information related to tangible investments for those in the decision 
                            making process. It can also be used for the maintenance of industrial plants and equipment.<br/>
                        </p>
                        <ul class="text-left">
                            <li>BIM (Building Information Modelling).</li>
                            <li>GIS (Geographic Information System).</li>
                            <li>ArcGIS (Geographic Information System) optional.</li>
                            <li>Allows for the lifecycle recording of asset consumption readings and related costs to identify changes which 
                                can be used to identify potential issues.</li>
                            <li>Intelligent workflow for automated trouble ticket generation, maintenance management, asset movement, etc.</li>
                            <li>2D and 3D geo-reference views.</li>
                            <li>Mobile interface.</li>
                            <li>Extend and integrate WorldCMMS™ with our powerful API.</li>
                        </ul>
                        <div>
                            <a target="_blank" href="../../../assets/solutions/Datasheets/WorldCMMS_Datasheet.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="ProjectPlanFX" class="info-title">ProjectPlanFX™ <br/>(Project Management)</h5>
                        <p class="info-text">
                            ProjectPlanFX™ is a cost effective yet powerful Project Management solution that is based upon the ContractFX™ milestone
                            management functionality, allowing you to plan projects and monitor team progress all in one place.<br/><br/>
                            ProjectPlanFX™ comes with enterprise-level security & scalability. Streamline requests, plan and prioritize projects,
                            manage processes, digitally review assets, and report on work efforts. Eliminate silos, increase productivity,
                            easily gather important information, collaborate with stakeholders, and work efficiently in either Waterfall 
                            or Agile functions by combining your work in one solution. <br/><br/>
                            Project Managers, Product Managers & Program Managers love ProjectPlanFX™ features such as: Gantt charts,
                            Workload View for resource management, Custom Dashboards, hieratical structuring via Folders, Projects, 
                            and tasks & auto-assignment based on task statuses.<br/>
                        </p>
                        <ul class="text-left">
                            <li>Mobile compatible - Track time, complete tasks and communicate on the move.</li>
                            <li>Time tracking - Easy timesheet entry and powerful reporting.</li>
                            <li>Resource Management - Allocate tasks and view workload across your business team.</li>
                            <li>Messaging & File Sharing</li>
                            <li>API - Extend and integrate ProjectPlanFX™ with our powerful API.</li>
                        </ul>
                        <div>
                            <a target="_blank" href="../../../assets/solutions/Datasheets/ProjectPlanFX_Datasheet.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/teamwork.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/HumanResourcesFlipped.jpg" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="WorldHRM" class="info-title">WorldHRM™ <br/> (Human Resources Management) </h5>
                        <p class="info-text">
                            With WorldHRM™, you pick exactly what you need and leave behind anything you don't.
                            Our individual modules are designed to solve your critical HR challenges - or all of your
                            HR challenges. Start with what you need now and add as you go.<br/>
                        </p>
                        <ul class="text-left">
                            <li>Quantify, measure and assign your requests on the go.</li>
                            <li>Graphical Reporting module allows you to create, view and gather information in an immersive visual interface.</li>
                            <li>Online Training helps organizations track and manage various employee accreditations that uphold their standards and that of the company.</li>
                            <li>Personnel Information Management (PIM)</li>
                            <li>Manage and access all your sensitive Employee Data, through one Organized, Secure and Centrally located Database from anywhere in the World.</li>
                            <li>Leave/Time-Off Management</li>
                            <li>Time & Attendance Management</li>
                            <li>Continuous tracking of employee performance with advanced metrics such as OKRs to dynamic objectives.</li>
                            <li>Recruitment</li>
                            <li>Streamline the hiring cycle with our recruitment and onboarding module.</li>
                            <li>Mobile interface.</li>
                            <li>Extend and integrate WorldHRM™ with our powerful API.</li>
                        </ul>
                        <div>
                            <a target="_blank" href="../../../assets/solutions/Datasheets/WorldHRM_Datasheet.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row info-item">
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-content">
                        <h5 id="WorldERP" class="info-title"> WorldERP® Vendor Network Portal</h5>
                        <p class="info-text">
                            WorldERP® Vendor Network is available for vendors and contractors to join in order to market, advertise, 
                            and sell their products and services to WorldERP® clients.<br/><br/>
                            Often, the client’s Buyers will ask vendors and contractors to join the WorldERP® Vendor Network in order to work
                            together more efficiently and effectively on all the shared aspects of business commerce: proposals & solicitations,
                            contracts, orders, invoices, and payments because using the WorldERP® Vendor Network can save both parties time and money.<br/><br/>
                            As a vendor/contractor on the WorldERP® Vendor Network, you are able to tap into one of the world’s largest commerce marketplaces,
                            with thousands of companies doing business, and signing up with the WorldERP® Vendor Network is 100% free, with no obligations or commitments.<br/>
                        </p>
                        <ul class="text-left">
                            <li>Accelerate the sales cycle while lowering the cost of sales.</li>
                            <li>Find new customers who are ready to buy.</li>
                            <li>Respond to RFI/RFQ/ITB/RFP and auctions, submit proposals, and negotiate contracts.</li>
                            <li>Upload catalogs for free and boost sales.</li>
                            <li>Manage purchase orders, send invoices, and receive payments.</li>
                            <li>Know when you’ll get paid and for what.</li>
                            <li>Strengthen customer relationships and increase customer retention. </li>
                        </ul>
                        <div>
                            <a target="_blank" href="../../../assets/solutions/Datasheets/VendorPortal_Datasheet.pdf">DATASHEET</a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="info-image">
                        <img src="../../../assets/solutions/VendorsContractors.png" width="495" class="img-responsive" alt="Global Presence">
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>